import React from "react";
import s from './ProductGrid.module.scss';
import { Grid, Card, CardContent, Typography, Button, Box } from "@mui/material";
import imagen1 from "./assets/K3.jpg";
import imagen3 from "./assets/K107.jpg";
import imagen4 from "./assets/K197.jpeg";
import imagen5 from "./assets/K199.jpeg";
import imagen6 from "./assets/P1238.jpg";
import imagen7 from "./assets/P1551.jpg";
import imagen8 from "./assets/P1676.jpg";
import imagen9 from "./assets/P1705.jpg";
import imagen10 from "./assets/P1910.jpg";
import imagen11 from "./assets/P2070.jpg";
import imagen12 from "./assets/P2290.jpg";
import imagen13 from './assets/gps-fustec.jpg';



function GameGrid() {

    const products = [
        { name: "GPS-FUSTEC - RASTREO SATELITAL PARA TU VEHICULO - SEGUIMIENTO EN TIEMPO REAL 24HS - BATERIA DE RESPALDO", image: imagen13, new: false, important: false },
        { name: "KIT COLOR VU 4X4: HIKVISION DS-7204HGHI-K1-S - 4 COLOR VU - DISCO SOLIDO 480GB - 4 BALUN ", image: imagen4, new: true, important: false },
        { name: "CAMARA IP CS-C3TN - H3C EZVIZ 1080P - 2.8MM 105Â° - WIFI - AUDIO - SLOT SD - IP67 - IR 30MS - CV310", image: imagen9, new: false, important: true},
        { name: "KIT ALARMA 100% INALAMBRICA TCP/IP LAN - WIFI - 3G/4G - 1 PHA48 4G, 1 PIR, 1 MAGNETICO - HIKVISION", image: imagen10, new: true, important: false },
        { name: "EZVIZ CS-C6N - PAN-TILT- WIFI - AUDIO BIDIRECCIONAL - SLOT M. SD - HIKVISION - CAMARA IP", image: imagen7, new: false, important: false },
        { name: "EZVIZ CS-C1C - C2C 1080P - AUDIO BIDIRECCIONAL - SLOT SD - LENTE 2,8 MM - CAMARA IP ", image: imagen11, new: false, important: true },
        { name: "KIT HIKVISION DS-7216HGHI-M1 - 16 CAMARAS 16-D0T-EXIPF 1080P - DISCO 1TB - 16 BALUN - FUENTE 10A", image: imagen3, new: false, important: true },
        { name: "KIT COLOR VU 8X8: 8 COLOR VU 10DF0T-PF - DISCO 1TB - 8 BALUN - 2 FUENTES - CONECTORES DC", image: imagen5, new: true, important: true },
        { name: "CAMARA IP EZVIZ H8C 2 MP - PAN -TILT - MICROFONO Y PARLANTE INTEGRADO - WIFI - IP66", image: imagen12, new: false, important: true },
        { name: "DSC KIT PC1555 - GABINETE - TRAFO - PLACA - TECLADO - PIR - SIRENA - BATERIA", image: imagen1, new: false, important: false },
        { name: "NT LINK 4G COMUNICADOR 4G DEDICADO PARA PANELES DSC - NETIO", image: imagen8, new: false, important: true },
        { name: "NT WIFI APP NETIO - APP CLICK COMUNICADOR IP WIFI COMPATIBLE DSC", image: imagen6, new: false, important: true },
        
        
    ];

    const defaultMessage = "Hola, estoy interesado en un producto!";
    const encodedMessage = encodeURIComponent(defaultMessage);
    const phoneNumber = "+5492235119636";
    const whatsappLink = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;

    return (
        <Grid container className={s.container} id='ProductGrid'>
            <Grid item xs={1} className={s.linecontainer}>
				<Box className={s.line1}></Box>
					<p>02</p>
				<Box className={s.line2}></Box>
			</Grid>
            <Grid item container xs={12} className={s.content}>
                <Grid item xs={10} className={s.title}>
                    <h3>Productos destacados</h3>
                </Grid>
                <Grid container spacing={3} xs={12}lg={10} sx={{ justifyContent: 'center', alignItems: 'center', marginLeft: '10%', marginRight: '10%', alignContent: 'center' }}>
                    {products?.length > 0 ? (
                        products.map((product, index) => (
                            <Grid item xs={12} sm={9} md={6} lg={3} key={index}> {/* Ajusta el ancho aquí */}
                                <Card
                                    style={{
                                        borderRadius: "15px",
                                        backgroundColor: "#222222",
                                        height: "100%", // Asegura que la tarjeta ocupe todo el ancho disponible
                                    }}
                                >
                                    <div className={s.cardImageContainer}>
                                        <img src={product.image} alt={product.name} className={s.cardImage} data-description={product.name} />
                                    </div>
                                    <CardContent style={{ backgroundColor: "#333333" }}>
                                        <Grid container spacing={2} justifyContent="center" alignItems="center">
                                            <Grid item xs={12}>
                                                <Typography
                                                gutterBottom
                                                align="center"
                                                component="div"
                                                style={{
                                                    color: "white",
                                                    fontWeight: 400,
                                                }}
                                                >
                                                {product.name}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                                <Button
                                                variant="contained"
                                                href={whatsappLink}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    padding: "5px 15px",
                                                    backgroundColor: "#df0e3d",
                                                    fontWeight: 500,
                                                    color: "EEEEEE",
                                                }}
                                                >
                                                Consultar
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))
                    ) : (
                        <Grid
                            item
                            container
                            xs={12}
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            sx={{ marginTop: "90px" }}
                        >
                            <Typography
                                variant="h4"
                                style={{ color: "white", paddingLeft: "10px", fontWeight: 500 }}
                            >
                                No hay Productos disponibles
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
}

export default GameGrid;